/**
 * "Vizualizate recent" — tracks the products a visitor has opened and renders
 * them back as cards.
 *
 * The history is a localStorage list of { h: handle, u: url } entries, newest
 * first. The url is captured from Liquid rather than rebuilt from the handle
 * because this theme does not expose Shopify.routes.root, and a hand-built
 * "/products/<handle>" would drop any locale or market prefix.
 *
 * Cards are fetched through the Section Rendering API so prices, badges and
 * variant ids stay server-rendered.
 */
(function () {
  var KEY = 'nasul-rosu:recently-viewed';
  var MAX_STORED = 20;

  function readHistory() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map(function (entry) {
          // Tolerate the older plain-handle format, and anything hand-edited.
          if (typeof entry === 'string') return { h: entry, u: '' };
          if (entry && typeof entry.h === 'string') {
            return { h: entry.h, u: typeof entry.u === 'string' ? entry.u : '' };
          }
          return null;
        })
        .filter(function (entry) {
          return entry && entry.h;
        });
    } catch (e) {
      // Private browsing, disabled storage, corrupt JSON — all non-fatal.
      return [];
    }
  }

  function writeHistory(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORED)));
    } catch (e) {
      /* storage full or unavailable — the carousel simply stays empty */
    }
  }

  function remember(handle, url) {
    if (!handle) return;
    var list = readHistory().filter(function (entry) {
      return entry.h !== handle;
    });
    list.unshift({ h: handle, u: url || '' });
    writeHistory(list);
  }

  function cardUrl(entry, sectionId) {
    var base = entry.u || '/products/' + encodeURIComponent(entry.h);
    // product.url can already carry a query string on some markets.
    var separator = base.indexOf('?') === -1 ? '?' : '&';
    return base + separator + 'section_id=' + encodeURIComponent(sectionId);
  }

  function fetchCard(entry, sectionId) {
    return fetch(cardUrl(entry, sectionId), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        return res.ok ? res.text() : null;
      })
      .then(function (html) {
        if (!html) return null;
        return new DOMParser().parseFromString(html, 'text/html').querySelector('.pc-card');
      })
      .catch(function () {
        // Product unpublished, deleted or offline — drop it silently.
        return null;
      });
  }

  function init(section) {
    if (section.dataset.rvInit) return;
    section.dataset.rvInit = '1';

    var current = section.getAttribute('data-rv-current-handle') || '';
    // Record this product first, then exclude it from its own carousel.
    remember(current, section.getAttribute('data-rv-current-url') || '');

    var track = section.querySelector('[data-rv-track]');
    if (!track) return;

    var clear = section.querySelector('[data-rv-clear]');
    if (clear) {
      clear.addEventListener('click', function () {
        writeHistory([]);
        track.innerHTML = '';
        section.hidden = true;
      });
    }

    var limit = parseInt(section.getAttribute('data-rv-limit'), 10);
    if (!limit || limit < 1) limit = 8;

    var sectionId = section.getAttribute('data-rv-card-section') || 'recently-viewed-card';
    var entries = readHistory()
      .filter(function (entry) {
        return entry.h !== current;
      })
      .slice(0, limit);

    if (!entries.length) return;

    Promise.all(
      entries.map(function (entry) {
        return fetchCard(entry, sectionId);
      })
    ).then(function (cards) {
      // Promise.all preserves order, so the newest product stays leftmost.
      var fragment = document.createDocumentFragment();
      var rendered = 0;

      cards.forEach(function (card) {
        if (!card) return;
        fragment.appendChild(document.importNode(card, true));
        rendered++;
      });

      if (!rendered) return;
      track.appendChild(fragment);
      section.hidden = false;
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-recently-viewed]').forEach(init);
  }

  if (document.readyState !== 'loading') initAll();
  else
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
